export default "__VITE_ASSET__BumvnotJ__"